import { render, staticRenderFns } from "./DocumentoSubTab.vue?vue&type=template&id=3865307e&"
import script from "./DocumentoSubTab.vue?vue&type=script&lang=js&"
export * from "./DocumentoSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports